import { defineStore } from 'pinia';
import { getNav } from '../../api/navigation/navigationSingle';
import type { NavigationNode } from '../../types/link';
import { useStoreConfiguration } from '../configuration/configuration';
import { watch, ref } from 'vue';

export type StoreAllNavs = {
  items: {
    mainNav: NavigationNode;
    secondaryNav: NavigationNode;
    metaNav: NavigationNode;
    socialNav: NavigationNode;
  };
};

const storeId = 'store-all-navs';
const type = 'primary,secondary,meta,social';

export const useStoreAllNavs = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();

  const allNavs = ref<StoreAllNavs['items']>();

  async function fetchItems() {
    const { caasConfig, caasUrl, config } = storeConfiguration;

    if (!caasConfig || !caasUrl || !config) {
      console.error(`${storeId} >>> error`, 'caas configuration or URL is not available');
      return;
    }

    const { caas_navigationServiceUrl: navigationServiceUrl } = config;
    const { project, instance, stage, language, locale, prefix } = caasConfig;

    const navItems = await getNav(
      caasUrl,
      navigationServiceUrl,
      project,
      instance,
      type,
      stage,
      language,
      locale,
      prefix,
      storeId,
    );

    if (navItems) {
      if (instance) {
        allNavs.value = {
          mainNav: navItems.find(
            (nav) => nav.instanceRoots[`${instance.toUpperCase()}`].indexOf('PRIMARY') !== -1,
          ),
          secondaryNav: navItems.find(
            (nav) => nav.instanceRoots[`${instance.toUpperCase()}`].indexOf('SECONDARY') !== -1,
          ),
          metaNav: navItems.find(
            (nav) => nav.instanceRoots[`${instance.toUpperCase()}`].indexOf('META') !== -1,
          ),
          socialNav: navItems.find(
            (nav) => nav.instanceRoots[`${instance.toUpperCase()}`].indexOf('SOCIAL') !== -1,
          ),
        };
      }
    }
  }

  watch(storeConfiguration, () => {
    if (storeConfiguration.config && !allNavs.value) {
      fetchItems();
    }
  });

  return {
    allNavs,
  };
});
